import React, { useEffect } from 'react';
import {
  TrendingUp,
  ShieldCheck,
  Truck,
  Building2,
  Car,
  CreditCard,
  Globe,
  Target,
  Mail,
  Phone,
  ArrowRight
} from 'lucide-react';
import '../style/Investor.css';
import bgImage from '../images/landingbackground.webp';

const Investor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const divisions = [
    {
      icon: <Building2 className="division-icon" />,
      title: "Construction Materials",
      desc: "Cement distribution and general construction materials Direct sourcing from manufacturers ensures competitive pricing and quality "
    },
    {
      icon: <Truck className="division-icon" />,
      title: "Transport & Logistics",
      desc: "Efficient delivery systems for bulk goods Strong focus on reliability and timely service"
    },
    {
      icon: <Car className="division-icon" />,
      title: "Vehicle Importation",
      desc: "Importation of quality vehicles tailored to client needs Advisory services to support buyers"
    },
    {
      icon: <ShieldCheck className="division-icon" />,
      title: "Customs Clearing",
      desc: "End-to-end logistics support for imports Reduced delays and cost optimization"
    },
    {
      icon: <CreditCard className="division-icon" />,
      title: "Financial Services",
      desc: "Mobile money distribution hub Partnerships with MNOs, banks, and fintech companies"
    }
  ];

  const stats = [
    { value: "ZMW 7.8M+", label: "Govt. Supplies Delivered" },
    { value: "3+", label: "Strategic Hub Locations" },
    { value: "100%", label: "Zero Quality Disputes" },
    { value: "SADC", label: "Regional Expansion Target" }
  ];

  return (
    <div className="investor-page">
      {/* HERO SECTION */}
      <section
        className="investor-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${bgImage})`
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-tag">
            <span className="dot"></span>
            Investor Relations
          </div>


          <h1>Driving Growth Through <span>Supply & Scale</span></h1>
          <p>
            Brolichi Creation Enterprise Limited is a fast-growing, multi-sector enterprise based in Zambia,
            delivering integrated solutions across construction supply, logistics, automotive importation, and financial services.

          </p>
          <div className="hero-btns">
            <a href="#opportunity" className="btn-primary">Explore Opportunity <ArrowRight size={18} /></a>
            <a href="#contact" className="btn-secondary">Get In Touch</a>
          </div>
        </div>
      </section>

      {/* STATS STRIP */}
      <section className="stats-strip">
        {stats.map((stat, i) => (
          <div key={i} className="stat-item">
            <h2>{stat.value}</h2>
            <p>{stat.label}</p>
          </div>
        ))}
      </section>

      {/* OPPORTUNITY SECTION */}
      <section id="opportunity" className="section opportunity-section">
        <div className="container">
          <div className="section-header">
            <span className="subtitle">The Opportunity</span>
            <h2>Zambia's Growth, <span>Our Momentum</span></h2>
          </div>

          <div className="opportunity-grid">
            <div className="opp-card">
              <div className="opp-icon-box"><TrendingUp /></div>
              <h3>Market Growth</h3>
              <p>Sustained demand in mining, construction, and national infrastructure programs (ZEEL & ZEEP).</p>
            </div>
            <div className="opp-card">
              <div className="opp-icon-box"><Target /></div>
              <h3>Integrated Model</h3>
              <p>One-stop solution capturing value across the entire supply chain—from sourcing to delivery.</p>
            </div>
            <div className="opp-card">
              <div className="opp-icon-box"><Globe /></div>
              <h3>Regional Scale</h3>
              <p>Strategically positioned to expand beyond Zambia into lucrative SADC regional markets.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BUSINESS MODEL / DIVISIONS */}
      <section className="section divisions-section">
        <div className="container">
          <div className="section-header centered">
            <span className="subtitle">Operational Excellence</span>
            <h2>Our Core <span>Business Divisions</span></h2>
          </div>

          <div className="divisions-grid">
            {divisions.map((div, i) => (
              <div key={i} className="division-card">
                <div className="icon-wrapper">{div.icon}</div>
                <h3>{div.title}</h3>
                <p>{div.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRACTION & COMPETITIVE ADVANTAGE */}
      <section className="section traction-section">
        <div className="container">
          <div className="traction-wrapper">
            <div className="traction-content">
              <span className="subtitle">Proven Traction</span>
              <h2>A Record of <span>Consistent Delivery</span></h2>
              <ul className="traction-list">
                <li>Proven track record of zero quality disputes in high-value supply contracts.</li>
                <li>Successfully supported national projects including ZEEL & ZEEP school supply programs.</li>
                <li>Multi-city operations established in Solwezi, Kitwe, and Lusaka.</li>
                <li>Strategic government and institutional relationships with full statutory compliance.</li>
              </ul>
            </div>
            <div className="advantage-box">
              <h3>Competitive Advantage</h3>
              <div className="adv-item">
                <div className="dot"></div>
                <p><strong>Integrated Ecosystem:</strong> Supply + Logistics + Finance</p>
              </div>
              <div className="adv-item">
                <div className="dot"></div>
                <p><strong>Cost Efficiency:</strong> Direct sourcing from major manufacturers</p>
              </div>
              <div className="adv-item">
                <div className="dot"></div>
                <p><strong>Risk Mitigation:</strong> Diversified revenue streams</p>
              </div>
              <div className="adv-item">
                <div className="dot"></div>
                <p><strong>Strong compliance framework:</strong> PACRA, ZRA, ZPPA</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INVESTMENT OPPORTUNITY */}
      <section className="section investment-section">
        <div className="container">
          <div className="glass-panel">
            <div className="section-header">
              <span className="subtitle">Scaling Operations</span>
              <h2>Strategic <span>Investment Pillars</span></h2>
            </div>

            <div className="investment-grid">
              <div className="inv-column">
                <h3>Investment Type</h3>
                <ul>
                  <li>Strategic Equity and Entering regional SADC markets</li>
                  <li>Expanding transport fleet and logistics infrastructure</li>
                  <li>Strengthening clearing & forwarding capacity</li>
                  <li>Increasing vehicle import volumes & Expanding fintech </li>
                </ul>
              </div>
              <div className="inv-column">
                <h3>Use of Funds</h3>
                <ul>
                  <li>Fleet and Logistics Infrastructure Expansion</li>
                  <li>Cement & Building Material Inventory Scaling</li>
                  <li>Regional SADC Market Entry</li>
                  <li>Fintech & Technology Platform Development</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RISK MANAGEMENT */}
      <section className="section risk-section">
        <div className="container">
          <div className="section-header centered">
            <span className="subtitle">Operational Resilience</span>
            <h2>Risk <span>Management</span></h2>
          </div>

          <div className="risk-grid">
            <div className="risk-card">
              <div className="dot"></div>
              <p>Diversified business segments reduce dependency risk</p>
            </div>
            <div className="risk-card">
              <div className="dot"></div>
              <p>Established supply chains and client base</p>
            </div>
            <div className="risk-card">
              <div className="dot"></div>
              <p>Compliance with all statutory requirements</p>
            </div>
            <div className="risk-card">
              <div className="dot"></div>
              <p>Risk exposure primarily limited to external factors (e.g., market conditions, force majeure)</p>
            </div>
          </div>
        </div>
      </section>

      {/* VISION & CTA */}
      <section id="contact" className="section contact-section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-left">
              <h2>Join Our <span>Vision</span></h2>
              <p>
                To become Zambia’s leading integrated supply, logistics, and
                infrastructure support company, and a key player across Southern Africa.
              </p>
            </div>
            <div className="cta-right">
              <div className="contact-info">
                <div className="info-item">
                  <Mail className="info-icon" />
                  <div>
                    <span>Email Us</span>
                    <p>admin@brolichi.com</p>
                  </div>
                </div>
                <div className="info-item">
                  <Phone className="info-icon" />
                  <div>
                    <span>Call Us</span>
                    <p>+260 760 958 585</p>
                  </div>
                </div>
              </div>
              <a href="/contact" target="_blank" rel="noopener noreferrer" className="btn-primary large">
                Connect With Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Investor;
